import { Component, inject, signal } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CONTACT_EMAIL } from '../constants';

@Component({
  selector: 'app-largest-capacity-modal',
  imports: [MatDialogModule],
  templateUrl: './largest-capacity-modal.html',
})
export class LargestCapacityModal {
  dialog = inject(MatDialog);

  protected readonly contactEmail = signal(CONTACT_EMAIL);

  closeDialog(): void {
    this.dialog.closeAll();
  }
}
